import { getStockRules } from '../../services/api/stockRule.api';
import { getReSyncAllocation, postReSyncAllocation } from '../../services/api/allocation.api';
import {
	GET_STOCK_RULE_LIST_REQUEST,
	GET_STOCK_RULE_LIST_SUCCESS,
	GET_STOCK_RULE_LIST_FAILURE,
	GET_ALLOCATION_STOCK_RULE_LIST_REQUEST,
	GET_ALLOCATION_STOCK_RULE_LIST_SUCCESS,
	GET_ALLOCATION_STOCK_RULE_LIST_FAILURE,
	POST_ALLOCATION_STOCK_RULE_LIST_REQUEST,
	POST_ALLOCATION_STOCK_RULE_LIST_SUCCESS,
	POST_ALLOCATION_STOCK_RULE_LIST_FAILURE,
} from '../types';
import { transformStockRules, transformAllocationChannel } from '../../transforms/allocation';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { mapTable } from '../../helpers/table';
import { ENV } from '../../enums/endpoint';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockRules([]),
		pagination: transformPagination({}),
		status: {},
	},

	getters: {
		tableData: (state) => mapTable(state.data, {
			// left side is transform keys, right side is table field keys
			id: 'id',
			name: 'name',
			priority: 'priority',
			totalBranches: 'total_branches',
			onlineRatio: 'online_ratio',
			minimum: 'min_qty',
			createdAt: 'created_at',
			isActive: 'status',
		}),
		stockRuleOptions: (state) => {
			//* hide for fix value is caseclub
			// const rule = {
			// 	name: 'All stock rules',
			// 	value: null,
			// };
			const rules = state.data.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});
			return rules;
			// return [rule, ...rules];
		},
	},

	mutations: {
		[GET_STOCK_RULE_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_STOCK_RULE_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			let stockRules = data;
			if (process.env.VUE_APP_NODE_ENV === ENV.DEV || process.env.VUE_APP_NODE_ENV === ENV.DEVELOPMENT) {
				stockRules = stockRules.filter((item) => item.id === 57); // case caseclub on dev
			} else {
				stockRules = stockRules.filter((item) => item.id === 57); // case caseclub on prd
			}
			state.data = transformStockRules(stockRules);
			state.pagination = transformPagination(meta);
		},
		[GET_STOCK_RULE_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		[GET_ALLOCATION_STOCK_RULE_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_ALLOCATION_STOCK_RULE_LIST_SUCCESS](state, data) {
			state.isLoading = false;
			state.status = transformAllocationChannel(data);
		},
		[GET_ALLOCATION_STOCK_RULE_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		[POST_ALLOCATION_STOCK_RULE_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[POST_ALLOCATION_STOCK_RULE_LIST_SUCCESS](state, data) {
			state.isLoading = false;
			state.status = transformAllocationChannel(data);
		},
		[POST_ALLOCATION_STOCK_RULE_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getStockRules({ commit }, params = {}) {
			try {
				commit(GET_STOCK_RULE_LIST_REQUEST);
				const { data } = await getStockRules({
					...params,
					per_page: params.perPage || 30,
				});
				commit(GET_STOCK_RULE_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_STOCK_RULE_LIST_FAILURE, error);
			}
		},
		async getReSyncAllocationStocks({ commit }) {
			try {
				commit(GET_ALLOCATION_STOCK_RULE_LIST_REQUEST);
				const { data } = await getReSyncAllocation();
				commit(GET_ALLOCATION_STOCK_RULE_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_ALLOCATION_STOCK_RULE_LIST_FAILURE, error);
			}
		},
		async postReSyncAllocationStocks({ commit }) {
			try {
				commit(POST_ALLOCATION_STOCK_RULE_LIST_REQUEST);
				const { data } = await postReSyncAllocation();
				commit(POST_ALLOCATION_STOCK_RULE_LIST_SUCCESS, data);
			} catch (error) {
				commit(POST_ALLOCATION_STOCK_RULE_LIST_FAILURE, error);
			}
		},
	},
};
